module.exports = __webpack_public_path__ + "assets/img/bidPriceRule.dda9396a.png";